import { USER_PREF_DEFAULT, PREF_KEY, AggregateTypePrefKeySuffix, } from "../constants/userpref";
import buildAggregateTypePrefKey from "../components/AreaProducts/utils/buildAggregateTypePrefKey";
const updatePreferences = (aggregateType, preferences, payload = {}) => {
    const updatedPreferences = {
        ...payload,
    };
    const unknown = {};
    const keysAccepted = new Set(Object.values(PREF_KEY));
    Object.values(AggregateTypePrefKeySuffix)
        .map((suffix) => buildAggregateTypePrefKey({ aggregateType, suffix }))
        .forEach((el) => keysAccepted.add(el));
    Object.keys(updatedPreferences).forEach((k) => {
        if (!keysAccepted.has(k)) {
            unknown[k] = updatedPreferences[k];
            delete updatedPreferences[k];
        }
    });
    if (Object.keys(unknown).length > 0) {
        console.log("[PREFERENCES_UNKNOWN]", unknown);
    }
    const newPreferences = {
        ...USER_PREF_DEFAULT,
        ...preferences,
        ...updatedPreferences,
    };
    return newPreferences;
};
export default updatePreferences;
